import {courseService} from '@jobseeker/common-core/services';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {Box, Typography} from '@mui/material';
import {Image} from '@jobseeker/lotus/components/Image';
import {useEffect, useState} from 'react';

const TopInstitutes = () => {
  const [topInstitutes, setTopInstitutes] = useState<
    {name: string; url: string; logoPath: string}[]
  >([]);

  useEffect(() => {
    (async () => {
      const {topInstitute} = (await courseService.getTopInstitutes()) as {
        topInstitute: Array<{name: string; url: string; logoPath: string}>;
      };

      setTopInstitutes(topInstitute);
    })();
  }, []);

  return (
    <Box textAlign="center" mt={10} bgcolor="rgb(243, 251, 251)" py={10}>
      <Typography
        fontSize={20}
        fontWeight={600}
        sx={{
          textDecoration: 'underline #f59f4b',
        }}
      >
        TOP INSTITUTES
      </Typography>
      <Box
        display="flex"
        gap={8}
        justifyContent="center"
        mt={5}
        flexWrap="wrap"
      >
        {topInstitutes.map(({logoPath, name, url}, idx) => (
          <Image
            key={idx}
            src={logoPath}
            alt={name}
            height={125}
            width={125}
            onClick={() => openUrl(url, '_blank')}
            style={{
              cursor: 'pointer',
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default TopInstitutes;
